export default {
    // name: 'common-logout-mixin',
    data: () => ({}),
    created () {},
    mounted () {},
    methods: {
        async commonLogout () {
            await this.$store.dispatch('logout')
            window.location.href = '/'
        }
    }
}